/**
 * Leitura das configuracoes da empresa.
 *
 * `companyId` entra na assinatura por causa do GERADOR (a previa mostra uma
 * configuracao por empresa) e para o `useCallback` da pagina refazer a busca
 * quando a administracao troca a empresa em foco. Ele NAO vai na query: o
 * tenant continua vindo da sessao (lib/api.ts, decisao 1).
 *
 * Nao recebe `range` de proposito: configuracao nao e recortada por janela de
 * tempo (mock.ts, decisao 2).
 *
 * Rota que o backend vai ter: `GET /api/settings`. A escrita sera por aba
 * (`PUT /api/settings/brand`, `/cadence`, `/integrations`, `/team`,
 * `/notifications`), mas na previa nada e enviado -- cada aba guarda em
 * estado local (GUIA-PAINEL, secao 3).
 */

import { fetchOrSimulate, type Envelope } from '../../lib/api';
import { simularConfiguracoes } from './mock';
import type { CompanySettings } from './types';

export function fetchConfiguracoes(companyId: string, signal: AbortSignal): Promise<Envelope<CompanySettings>> {
  return fetchOrSimulate('/api/settings', {}, signal, () => simularConfiguracoes(companyId));
}
